var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Doughnut',{attrs:{"id":"my-chart-id","options":_vm.chartOptions,"chart-data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }